const sellerCloudChannels = [
	{ label: 'Amazon', value: 4 },
	{ label: 'Website', value: 6 },
	{ label: 'Overstock', value: 22 },
	{ label: 'Wayfair', value: 27 },
	{ label: 'Walmart', value: 42 },
	{ label: 'Home Depot', value: 72 },
	{ label: 'Local Store', value: 0 },
	{ label: 'eBay Order', value: 1 },
	{ label: 'eBay Single Item', value: 2 },
	{ label: 'Yahoo', value: 3 },
	{ label: 'Price Grabber', value: 5 },
	{ label: 'Buy', value: 7 },
	{ label: 'New Egg Mall', value: 12 },
	{ label: 'Magento', value: 15 },
	{ label: 'Quick Books', value: 16 },
	{ label: 'RMS', value: 17 },
	{ label: 'Cart32', value: 18 },
	{ label: 'Sears', value: 19 },
	{ label: 'Wholesale', value: 21 },
	{ label: 'New Eggdotcom', value: 23 },
	{ label: 'Etsy', value: 24 },
	{ label: 'Bonanza', value: 25 },
	{ label: 'Price Falls', value: 26 },
	{ label: 'Unbeatable Sale', value: 28 },
	{ label: 'Hayneedle', value: 30 },
	{ label: 'Smart Bargains', value: 31 },
	{ label: 'uBid', value: 32 },
	{ label: 'ATG Stores', value: 33 },
	{ label: 'Stacks And Stacks', value: 34 },
	{ label: 'Sharkstores', value: 35 },
	{ label: 'Best Buy', value: 36 },
	{ label: 'Kohls', value: 37 },
	{ label: 'Staples', value: 38 },
	{ label: 'One Stop Plus', value: 39 },
	{ label: 'Meijer', value: 40 },
	{ label: 'Sonsi', value: 41 },
	{ label: 'HSN', value: 43 },
	{ label: 'New Egg Business', value: 44 },
	{ label: 'KMart', value: 45 },
	{ label: 'Wish', value: 46 },
	{ label: 'SP Richards', value: 47 },
	{ label: 'FingerHut', value: 48 },
	{ label: 'Groupon', value: 49 },
	{ label: 'Walmart Marketplace', value: 50 },
	{ label: 'Shop HQ', value: 51 },
	{ label: 'Price Minister', value: 52 },
	{ label: 'GS', value: 53 },
	{ label: 'Drug Store', value: 54 },
	{ label: 'Mercado Libre', value: 55 },
	{ label: 'JET', value: 56 },
	{ label: 'Eleven Main', value: 57 },
	{ label: 'Sears Vendor', value: 58 },
	{ label: 'Choxi/No More Racks', value: 59 },
	{ label: 'TradeMe ', value: 60 },
	{ label: 'Tanga', value: 61 },
	{ label: 'Target', value: 62 },
	{ label: 'Groupon Marketplace', value: 63 },
	{ label: 'Reverb', value: 64 },
	{ label: 'Bed Bath And Beyond', value: 65 },
	{ label: 'Dropship Central', value: 66 },
	{ label: 'DSW', value: 67 },
	{ label: 'Houzz', value: 68 },
	{ label: 'Gilt', value: 69 },
	{ label: 'Best Buy DS', value: 70 },
	{ label: 'Top Hatter', value: 71 },
	{ label: 'Mass Genie', value: 73 },
	{ label: 'Cdiscount', value: 74 },
	{ label: 'Groupon Gateway', value: 75 },
	{ label: 'SBN', value: 76 },
	{ label: 'Google Express', value: 77 },
	{ label: 'Target Plus', value: 78 },
	{ label: 'WFS', value: 79 },
];

export { sellerCloudChannels };



// WEBPACK FOOTER //
// ./src/common/constants/sellerCloudChannelsConstants.js